import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Container from './Container';
import { FaFacebookF, FaLinkedin, FaHeart, FaBell, FaEnvelope, FaPhone, FaMapMarkerAlt, FaApple } from 'react-icons/fa';
import { FaTwitter, FaCartShopping, FaBoxOpen, FaInstagram, FaGooglePlay } from 'react-icons/fa6';
import { FaCcVisa, FaCcMastercard, FaCcAmex, FaCcDiscover, FaCcPaypal, FaCcApplePay, FaGooglePay } from 'react-icons/fa';
import { useSelector } from 'react-redux';

const Footer = () => {
  const navigate = useNavigate();
  const { userInfo } = useSelector(state => state.auth);
  const { card_product_count, wishlist_count } = useSelector(state => state.card);

  return (
    <footer>

      {/* ===== MAIN FOOTER ===== */}
      <div className="bg-[#1a1a1a] text-gray-300">
        <Container className="py-14 grid grid-cols-4 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-10">

          {/* BRAND COLUMN */}
<div className="flex flex-col gap-5">
  <p className="text-sm text-gray-400 leading-relaxed max-w-[320px]">
    Your trusted marketplace for quality products across the UAE and beyond.
    Fast delivery, genuine items, and great prices.
  </p>

            <ul className="flex flex-col gap-2 text-sm">
              <li className="flex items-start gap-2.5">
                <FaMapMarkerAlt className="text-[#E21C1B] mt-0.5 flex-shrink-0" />
                <span className="text-gray-400">Dubai Silicon Oasis, Dubai, UAE</span>
              </li>
              <li className="flex items-center gap-2.5">
                <FaPhone className="text-[#E21C1B] flex-shrink-0" />
                <span className="text-gray-400">+971 4 000 0000</span>
              </li>
              <li className="flex items-center gap-2.5">
                <FaEnvelope className="text-[#E21C1B] flex-shrink-0" />
                <span className="text-gray-400">support@pikkodubai.com</span>
              </li>
            </ul>
            <div className="flex gap-2.5 mt-1">
              {[
                { icon: <FaFacebookF size={20} />, href: '#' },
                { icon: <FaTwitter size={20} />, href: '#' },
                { icon: <FaInstagram size={20} />, href: '#' },
                { icon: <FaLinkedin size={20} />, href: '#' },
              ].map((s, i) => (
                <a key={i} href={s.href}
                  className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#E21C1B] transition text-white">
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-5 uppercase tracking-widest">Shop</h3>
            <ul className="flex flex-col gap-3 text-sm">
              {[
                ['/products?sort=best-selling', 'Best Selling'],
                ['/products?sort=new', 'New Arrivals'],
                ['/products?rating=5', '5-Star Rated'],
                ['/bulk-products', 'Bulk Products'],
                ['/wholesale-products', 'Wholesale'],
                ['/become-seller', 'Become a Seller'],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-gray-400 hover:text-white transition hover:pl-1 duration-200 block">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* INFO LINKS */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-5 uppercase tracking-widest">Help</h3>
            <ul className="flex flex-col gap-3 text-sm">
              {[
                ['/faq', 'FAQ'],
                ['/about', 'About Us'],
                ['/contact', 'Contact Us'],
                ['/terms', 'Terms & Conditions'],
                ['/dashboard/my-orders', 'Track My Order'],
                ['/dashboard/my-profile', 'My Account'],
                ['/blog', 'Blog'],
              ].map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-gray-400 hover:text-white transition hover:pl-1 duration-200 block">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* NEWSLETTER */}
          <div>
            <h3 className="text-white font-semibold text-sm mb-5 uppercase tracking-widest">Stay Updated</h3>
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Subscribe for exclusive deals, new arrivals and special offers.
            </p>
            <div className="flex rounded-lg overflow-hidden border border-white/10">
              <input
                type="email"
                placeholder="Your email address"
                className="flex-1 bg-white/5 text-white placeholder-gray-500 px-4 py-2.5 text-sm outline-none focus:bg-white/10 transition"
              />
              <button className="bg-[#E21C1B] text-white px-4 text-sm font-semibold hover:bg-[#c01717] transition whitespace-nowrap">
                Subscribe
              </button>
            </div>
            <p className="text-[11px] text-gray-500 mt-2">No spam. Unsubscribe anytime.</p>

            <div className="mt-6">
              <p className="text-xs text-gray-500 mb-3 uppercase tracking-wide">Download our app</p>
              <div className="flex gap-2">
                <div className="bg-black border border-white/15 rounded-full pl-3 pr-4 py-1.5 flex items-center gap-2 cursor-pointer hover:bg-[#0d0d0d] transition">
                  <FaApple size={18} className="text-white flex-shrink-0" />
                  <div className="leading-tight">
                    <p className="text-[8px] text-gray-400">Download on the</p>
                    <p className="text-[12px] text-white font-semibold -mt-0.5">App Store</p>
                  </div>
                </div>
                <div className="bg-black border border-white/15 rounded-full pl-3 pr-4 py-1.5 flex items-center gap-2 cursor-pointer hover:bg-[#0d0d0d] transition">
                  <FaGooglePlay size={16} className="text-[#00C2FF] flex-shrink-0" />
                  <div className="leading-tight">
                    <p className="text-[8px] text-gray-400">Get it on</p>
                    <p className="text-[12px] text-white font-semibold -mt-0.5">Google Play</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </Container>
      </div>

      {/* ===== SECURITY & PAYMENT METHODS ===== */}
      <div className="bg-[#1a1a1a] border-t border-white/10">
        <Container className="flex flex-wrap items-start justify-between gap-8 py-8">

          {/* SECURITY CERTIFICATION */}
          <div>
            <p className="text-xs font-semibold text-white mb-3">Security certification</p>
            <div className="flex flex-wrap items-center gap-1.5">
              {[
                { label: 'PCI DSS', sub: 'COMPLIANT' },
                { label: 'VISA', sub: 'SECURE' },
                { label: 'ID Check', sub: '' },
                { label: 'SafeKey', sub: '' },
                { label: 'JCB', sub: 'J/Secure' },
                { label: 'APWG', sub: '' },
              ].map((c, i) => (
                <div
                  key={i}
                  className="h-7 px-2 rounded border border-gray-300 bg-white flex flex-col items-center justify-center leading-none"
                >
                  <span className="text-[8px] font-bold text-gray-800">{c.label}</span>
                  {c.sub && <span className="text-[6px] text-gray-500 tracking-tight">{c.sub}</span>}
                </div>
              ))}
            </div>
          </div>

          {/* WE ACCEPT */}
          <div>
            <p className="text-xs font-semibold text-white mb-3">We accept</p>
            <div className="flex flex-wrap items-center gap-1.5">
              {[
                { icon: <FaCcPaypal size={22} />, label: 'PayPal', color: '#003087' },
                { icon: <FaCcVisa size={22} />, label: 'Visa', color: '#1A1F71' },
                { icon: <FaCcMastercard size={22} />, label: 'Mastercard', color: '#EB001B' },
                { icon: <FaCcAmex size={22} />, label: 'Amex', color: '#2E77BC' },
                { icon: <FaCcDiscover size={22} />, label: 'Discover', color: '#FF6000' },
                { icon: <FaCcApplePay size={22} />, label: 'Apple Pay', color: '#000000' },
                { icon: <FaGooglePay size={22} />, label: 'Google Pay', color: '#5F6368' },
              ].map((p, i) => (
                <div
                  key={i}
                  title={p.label}
                  className="w-11 h-7 rounded border border-gray-300 bg-white flex items-center justify-center"
                  style={{ color: p.color }}
                >
                  {p.icon}
                </div>
              ))}
              <div
                title="RuPay"
                className="w-11 h-7 rounded border border-gray-300 bg-white flex items-center justify-center"
              >
                <span className="text-[9px] font-extrabold tracking-tight">
                  <span className="text-[#0C4E9B]">Ru</span><span className="text-[#F58220]">Pay</span>
                </span>
              </div>
            </div>
          </div>

        </Container>
      </div>

      {/* ===== BOTTOM BAR ===== */}
      <div className="bg-black">
        <Container className="flex flex-wrap items-center justify-between gap-4 py-4 text-xs text-gray-500">
          <span>© 2024 Pikko Dubai. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-gray-300 transition">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-gray-300 transition">Terms of Use</Link>
          </div>
        </Container>
      </div>

      {/* ===== MOBILE BOTTOM NAV ===== */}
      {/* Spacer so the fixed bar never covers the end of the footer */}
      <div className="hidden md-lg:block h-[60px] bg-black" />
      <nav
        className="hidden fixed md-lg:flex bottom-0 left-0 right-0 h-[60px] bg-white border-t border-gray-200 shadow-[0_-2px_10px_rgba(0,0,0,0.06)] z-50"
        style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      >
        {[
          { label: 'Alerts', icon: <FaBell size={17} />, action: () => navigate(userInfo ? '/notifications' : '/login') },
          { label: 'Orders', icon: <FaBoxOpen size={17} />, action: () => navigate(userInfo ? '/dashboard/my-orders' : '/login') },
          { label: 'Cart', icon: <FaCartShopping size={17} />, action: () => navigate(userInfo ? '/card' : '/login'), badge: card_product_count },
          { label: 'Wishlist', icon: <FaHeart size={17} />, action: () => navigate(userInfo ? '/dashboard/my-wishlist' : '/login'), badge: wishlist_count },
        ].map((item) => (
          <button
            key={item.label}
            onClick={item.action}
            className="flex-1 flex flex-col items-center justify-center gap-0.5 text-[#E21C1B] active:bg-[#fff0f0] transition"
          >
            <span className="relative">
              {item.icon}
              {item.badge > 0 && (
                <span className="absolute -top-2 -right-3 min-w-[16px] h-4 px-1 bg-[#E21C1B] text-white text-[9px] font-bold rounded-full flex items-center justify-center">
                  {item.badge}
                </span>
              )}
            </span>
            <span className="text-[11px] font-medium text-gray-600">{item.label}</span>
          </button>
        ))}
      </nav>

    </footer>
  );
};

export default Footer;
